<template>
  <div>
    <el-button
      type="primary"
      @click="addCLassForStu"
      :size="btnSize"
      :disabled="btnDisable"
      icon="upload2"
    >
      <slot></slot>
    </el-button>
    <Modal v-model="modalShow" width="800" footer-hide>
      <p slot="header" style="text-align: center; font-size: 15px">
        <Icon type="ios-information-circle"></Icon>
        <span>
          <slot></slot>
        </span>
      </p>

      <!-- <queryClassBar @queryResult="queryHandle" /> -->
       <el-form :inline="true" :model="formClass" label-width="90px" class="searchForm">
      <el-form-item label="班级名称:">
        <el-input v-model="formClass.name" placeholder="输入班级名称"></el-input>
      </el-form-item>
      <el-form-item label="开课时间:" label-width="110px">
        <el-date-picker
          v-model="formClass.startTime"
          type="daterange"
          placeholder="开课时间"
          format="yyyy-MM-dd"
          placement="bottom-end"
          style="width:250px;font-size:10px"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="search" @click="onQuery">搜索</el-button>
      </el-form-item>
    </el-form>
      <div>
        <el-table
          ref="multipleTable"
          :data="queryData"
          stripe
          border
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          class="el-table" 
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <!-- <el-table-column label width="80" align="center">
            <template slot-scope="scope">
              <el-radio :label="scope.row.classId" v-model="tempRadio">{{
                ""
              }}</el-radio>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="classId"
            label="班级ID"
            align="center"
            width="90"
          >
          
                <!-- @click="viewClass(scope.row)" -->
            <template slot-scope="scope">
              <a
                href="javascript:;"
                style="color: #1d90e6"
                >{{ scope.row.classId }}</a
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="班级名称"
            align="center"
            min-width="120"
          >
            <template slot-scope="scope">
              <a
                href="javascript:;"
                style="color: #1d90e6"
                >{{ scope.row.name }}</a
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="startTime"
            label="开课时间"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="mainTeacher.name"
            label="老师"
            align="center"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="enabled"
            label="状态"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.enabled" type="success">已上架</el-tag>
              <el-tag v-else type="danger">已下架</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="操作"
            show-overflow-tooltip
            align="center"
            width="90"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-tooltip content="编辑" placement="top">
                <el-button
                  type="info"
                  icon="edit"
                  size="mini"
                  @click="handleEdit(scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column> -->
        </el-table>
        <div class="pagination-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="queryParams.page"
            :page-sizes="[20, 50, 100]"
            :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal"
          ></el-pagination>
        </div>
      </div>
      <Divider />
      <el-button type="primary" @click="modalConfirm" style="margin-left: 300px"
        >确定</el-button
      >
      <el-button type="primary" @click="modalCancel">取消</el-button>
    </Modal>
  </div>
</template>

<script>
import { ApiMessage, formatDate } from "@/utils/util";
import { formatDateString } from "../commonEdu";
import queryClassBar from "./queryClassBar";
export default {
  name: "stuAddClass",
  components: { queryClassBar },
  data() {
    return {
       formClass: {
        name: "",
        level: "",
        startTime: [],
      },
      modalShow: false,
      pageTotal: 0,
      queryData: [],
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      loading: true,
      queryTerms: null,
      tempRadio: "",
      multipleSelection: {},
    };
  },
  props: {
    oldClass: {
      type: Number,
      default: null,
    },
    btnDisable: {
      type: Boolean,
      default: false,
    },
    btnSize: {
      type: String,
      default: "mini",
    },
    len: {
      type: Number,
      default: 1,
    },
      stuData: {
      type: Array,
     default:()=>[]
    },
  },
  created() {},
  watch: {},
  methods: {
    addCLassForStu() {
     this.tempRadio = '' 
      if (this.len > 0) {
        //  let statuShow = [];
        // for (let i in this.stuData) {
        //   statuShow.push(`${this.stuData[i].status}`);
        // }
        // if (statuShow.includes("2")) {
        //   alert("该学员已经离开班级，不可以做此操作");
        //   return;
        // }
        this.modalShow = true;
        this.fetchClassList();
      } else {
        alert("请先选择学生");
        return;
      }
    },
    onQuery(param){
      this.queryParams.page = 1;
      this.queryTerms = param;

       this.fetchClassList();
    },
    fetchClassList() {
      // debugger
      this.loading = true;
      let params = {
        appId: this.$API.APPID,
      };
      // if (this.queryTerms != null) {
        if (this.formClass.name != "") {
          params.name = this.formClass.name;
        }
        if (this.formClass.level != "") {
          params.level = this.formClass.level;
        }
        if (this.formClass.startTime&&this.formClass.startTime.length&&this.formClass.startTime.length == 2) {
          if (
            this.formClass.startTime[0] != null &&
            this.formClass.startTime[1] != null
          ) {
            params.startTime = [
              formatDateString(this.formClass.startTime[0]),
              formatDateString(this.formClass.startTime[1]),
            ];
          }
        }
      // }
      params.pageSize = this.queryParams.pageSize;
      params.page = this.queryParams.page;
      this.eduAxiosPostRequest("/edu/eduAdmin/class/list", params).then(
        (res) => {
          if (res != null) {
            let m = JSON.parse(res);
            this.queryData = m.list;
            this.pageTotal = m.pager.total;
          }
          this.loading = false;
        }
      );
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.fetchClassList();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.fetchClassList();
    },
    modalConfirm() {
      console.log(this.multipleSelection);

      console.log(this.tempRadio);
      // debugger;
      if (this.oldClass == null) {
        this.$emit("classResult", this.multipleSelection);
      } else {
        this.$emit("classResult", [`${this.oldClass}`],this.multipleSelection);
      }
      this.modalShow = false;
    },
    modalCancel() {
      this.modalShow = false;
    },
    // queryHandle(param) {
    //   console.log(param);
    //   this.queryParams.page = 1
    //   this.queryTerms = param;
    //   this.fetchClassList();
    // },
    // handleSelect(val) {
    //   this.multipleSelection = val;
    // },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            console.log(response);
            if (response.data.rc == "0") {
              resolve(JSON.stringify(response.data.data));
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style lang="less">
body .el-table::before {
    z-index: inherit;
}
</style>


// WEBPACK FOOTER //
// stuAddClass2.vue?4b523a4a